var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element)?_c('v-row',{staticClass:"mb-3",attrs:{"no-gutters":"","justify":"center"}},[_c('CompSpeak',{attrs:{"compSettings":`{ "hideText": ${_vm.element.hideText}, "dense": ${_vm.element.dense}, "pitch": ${_vm.element.pitch}, "rate": ${_vm.element.rate} }`,"text":_vm.element.text}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }